// BUG-2354: props for on-screen keypad buttons so they never take keyboard focus.
// A focused <button> turns a physical Enter into another click (re-appending the last
// digit / re-firing the key) instead of reaching the amount/quantity input's Enter handler.
// preventDefault on mousedown only blocks the focus change; onClick still fires for
// mouse and touch, and tabIndex -1 keeps the keys out of the Tab order.
export const KEYPAD_NO_FOCUS = Object.freeze({
  tabIndex: -1,
  onMouseDown: (e) => e.preventDefault(),
});
